if (!customElements.get('payment-shipping-info')) {
  customElements.define(
    'payment-shipping-info',
    class PaymentShippingInfo extends HTMLElement {
      constructor() {
        super();
        this.cuotasRow = this.querySelector('[data-row="cuotas"]');
        this.moneyFormat = this.dataset.moneyFormat || '${{amount}}';
      }

      connectedCallback() {
        if (!this.cuotasRow) return;

        this.variantChangeUnsubscriber = FoxTheme.pubsub.subscribe(
          FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange,
          (event) => {
            if (event.data.sectionId !== this.dataset.sectionId) return;
            this.updateCuotas(event.data.variant);
          }
        );
      }

      disconnectedCallback() {
        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
        }
      }

      updateCuotas(variant) {
        if (!variant || typeof variant.price !== 'number') {
          this.cuotasRow.hidden = true;
          return;
        }
        this.cuotasRow.hidden = false;

        const count = parseInt(this.cuotasRow.dataset.cuotasCount, 10) || 1;
        const interest = parseInt(this.cuotasRow.dataset.cuotasInterest, 10) || 0;
        const template = this.cuotasRow.dataset.cuotasTemplate || '';

        if (count <= 0) {
          this.cuotasRow.hidden = true;
          return;
        }

        const cuotaCents = Math.round((variant.price * (100 + interest)) / 100 / count);
        const monto = this.formatMoney(cuotaCents, this.moneyFormat);
        const textEl = this.cuotasRow.querySelector('[data-psi-text]');

        if (textEl) {
          textEl.textContent = template.replace(/\{cuotas\}/g, count).replace(/\{monto\}/g, monto);
        }
      }

      formatMoney(cents, format) {
        const value = (cents || 0) / 100;
        const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
        const match = format.match(placeholderRegex);
        if (!match) return format;

        let formatted;
        switch (match[1]) {
          case 'amount':
            formatted = this.formatWithDelimiters(value, 2, ',', '.');
            break;
          case 'amount_no_decimals':
            formatted = this.formatWithDelimiters(value, 0, ',', '.');
            break;
          case 'amount_with_comma_separator':
            formatted = this.formatWithDelimiters(value, 2, '.', ',');
            break;
          case 'amount_no_decimals_with_comma_separator':
            formatted = this.formatWithDelimiters(value, 0, '.', ',');
            break;
          case 'amount_with_space_separator':
            formatted = this.formatWithDelimiters(value, 2, ' ', ',');
            break;
          case 'amount_no_decimals_with_space_separator':
            formatted = this.formatWithDelimiters(value, 0, ' ');
            break;
          case 'amount_with_apostrophe_separator':
            formatted = this.formatWithDelimiters(value, 2, "'", '.');
            break;
          default:
            formatted = this.formatWithDelimiters(value, 2, ',', '.');
        }

        return format.replace(placeholderRegex, formatted);
      }

      formatWithDelimiters(number, precision = 2, thousands = ',', decimal = '.') {
        if (isNaN(number) || number === null) return '0';

        const parts = number.toFixed(precision).split('.');
        const intPart = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
        const decPart = parts[1] ? decimal + parts[1] : '';

        return intPart + decPart;
      }
    }
  );
}
